import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    selectedLocale: function () { return getRegionalOptions().selectedLocale; },
    selectedDateFormat: function () { return getRegionalOptions().selectedDateFormat; },
    selectedTimeFormat: function () { return getRegionalOptions().selectedTimeFormat; },
    selectedTimeZone: function () { return getRegionalOptions().selectedTimeZone; },
    savedLocale: function () { return getUserConfiguration().SessionSettings.UserCulture; },
    savedDateFormat: function () { return getUserConfiguration().UserOptions.DateFormat; },
    savedTimeFormat: function () { return getUserConfiguration().UserOptions.TimeFormat; },
    savedTimeZone: function () { return getUserConfiguration().UserOptions.TimeZone; },
})(function isRegionalOptionDirty(state) {
    var selectedLocale = state.selectedLocale, selectedDateFormat = state.selectedDateFormat, selectedTimeFormat = state.selectedTimeFormat, selectedTimeZone = state.selectedTimeZone, savedLocale = state.savedLocale, savedDateFormat = state.savedDateFormat, savedTimeFormat = state.savedTimeFormat, savedTimeZone = state.savedTimeZone;
    return ((selectedLocale !== null && selectedLocale !== savedLocale) ||
        (selectedDateFormat !== null && selectedDateFormat !== savedDateFormat) ||
        (selectedTimeFormat !== null && selectedTimeFormat !== savedTimeFormat) ||
        (selectedTimeZone !== null && selectedTimeZone !== savedTimeZone));
});
//# sourceMappingURL=isRegionalOptionDirty.js.map